<script setup lang="ts">
import type { TProps as TAccordionProps } from './BaseAccordion.vue'

type TItems = Array<
  { data: TCommonLinkModel }[] | { data: TNavigationLinkListEntry }[]
>

type TProps = { items: TItems } & Pick<
  TAccordionProps,
  'allowExpandMultiple' | 'initialOpenedItems'
> &
  TBuilderBaseProps

const props = withDefaults(defineProps<TProps>(), {
  allowExpandMultiple: false,
  initialOpenedItems: () => [0],
  attributes: () => ({}),
})

const normalizedItems = computed(() => {
  if (!props.items) {
    return []
  }

  const items = toValue(props.items)

  const flattenedItems = items
    .flat()
    .map((item) => item.data)
    .filter(Boolean)

  return esReverse(
    esMap(
      esGroupBy(flattenedItems, (item) => {
        if ('menuCategory' in item) {
          return item.menuCategory
        }
        if ('title' in item) {
          return item.title
        }
        return 'Uncategorized'
      }),
      (itemsInGroup, categoryName) => ({
        title: categoryName,
        content:
          itemsInGroup[0] && 'links' in itemsInGroup[0]
            ? itemsInGroup[0].links
            : itemsInGroup,
      })
    )
  )
})
</script>

<template>
  <div class="w-full">
    <LazyBaseAccordion
      v-bind="props"
      :items="
        normalizedItems as {
          title: string
          content: string | TCommonLinkModel | TCommonLinkModel[]
        }[]
      "
    >
      <template #default="{ item }">
        <div v-if="item.content" class="flex flex-col gap-4 pb-4">
          <template v-if="Array.isArray(item.content)">
            <NuxtLink
              v-for="(link, index) in item.content"
              :key="`accordion-link-div-${index}`"
              :to="('url' in link && link.url) || '#'"
              class="text-trail-text-body-normal text-trail-text-link px-4"
            >
              {{ link.text }}
            </NuxtLink>
          </template>
        </div>
      </template>
    </LazyBaseAccordion>
  </div>
</template>
